import axios from "axios";
import { getCookie } from "utils/setCookie";

export const fetchUsers = async (
  page: number = 1,
  limit: number = 10,
  searchQuery: string = ""
) => {
  const url = `${process.env.REACT_APP_AJAX_URL}user/list`;
  try {
    const response = await axios.get(url, {
      params: { page, limit, display_name: searchQuery },
      headers: {
        "X-Authorization": getCookie("session"),
      },
    });
    return response.data || [];
  } catch (error) {
    console.error("Failed to fetch user data", error);
    return [];
  }
};

export const getListChat = async (
  orderBy: string,
  page: number = 1,
  limit: number = 10
): Promise<any> => {
  const url =
    process.env.REACT_APP_AJAX_URL +
    `chat-room/list-for-admin?order_by=${orderBy}&page=${page}&limit=${limit}`;
  try {
    const axiosConfig = {
      headers: {
        "X-Authorization": getCookie("session"),
      },
    };

    return await axios.get(url, axiosConfig);
  } catch (error) {
    throw new Error("Failed to fetch chat room data");
  }
};

export const createChat = async (
  partner_id: string,
  chat_type: "personal"
): Promise<any> => {
  const requestData = {
    partner_id,
    chat_type,
  };
  const axiosConfig = {
    headers: {
      "X-Authorization": getCookie("session"),
    },
  };
  const url = process.env.REACT_APP_AJAX_URL + `chat-room/create`;
  return axios.post(url, requestData, axiosConfig);
};

export const createGroupChat = async (
  partner_id: string,
  room_name: string,
  chat_type: "group"
): Promise<any> => {
  const requestData = {
    partner_id,
    room_name,
    chat_type,
  };
  const axiosConfig = {
    headers: {
      "X-Authorization": getCookie("session"),
    },
  };
  const url = process.env.REACT_APP_AJAX_URL + `chat-room/create`;
  return axios.post(url, requestData, axiosConfig);
};
